import React from "react";
import "./style.scss";

export type BadgeType =
  | "primary"
  | "success"
  | "danger"
  | "success-green"
  | "warning"
  | "info"
  | "teal"
  | "primary-border"
  | "custom"
  | "completed-green"
  | "completed-blue"
  | "short-assessment"
  | "long-assessment-purple";

interface BadgeProps {
  label?: string;
  type?: BadgeType;
  className?: string;
  customColor?: string;
  /** Native browser tooltip when the badge needs a short explanation. */
  title?: string;
  children?: React.ReactNode;
}

const Badge: React.FC<BadgeProps> = ({
  label,
  type = "",
  className = "",
  customColor,
  title,
  children,
}) => {
  const baseClass = "custom-badge";
  const typeClass = `badge-${type}`;
  const finalClass = [baseClass, typeClass, className]
    .filter(Boolean)
    .join(" ");

  const customStyle =
    type === "custom" && customColor
      ? { backgroundColor: customColor }
      : undefined;

  return (
    <span className={finalClass} style={customStyle} title={title}>
      {label}
      {children}
    </span>
  );
};

export default Badge;
